/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review6_QuoteInputs */

const es_landing_review6_quote = /** @type {(inputs: Landing_Review6_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente: puesta de sol increíble y al llegar a puerto las luces de Vigo. El patrón muy atento. Repito seguro.`)
};

const gl_landing_review6_quote = /** @type {(inputs: Landing_Review6_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente: solpor incrible e ao chegar ao porto as luces de Vigo. O patrón moi atento. Repito seguro.`)
};

const en_landing_review6_quote = /** @type {(inputs: Landing_Review6_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent: amazing sunset and the Vigo lights as we reached port. Very attentive skipper. I will repeat.`)
};

/**
* | output |
* | --- |
* | "Excellent: amazing sunset and the Vigo lights as we reached port. Very attentive skipper. I will repeat." |
*
* @param {Landing_Review6_QuoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review6_quote = /** @type {((inputs?: Landing_Review6_QuoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review6_QuoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review6_quote(inputs)
	if (locale === "en") return en_landing_review6_quote(inputs)
	return es_landing_review6_quote(inputs)
});